var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.22.006H8.142s-5.2-.376-5.2 4.921v3.64H0l.009 2.853h2.933v12.531H7.06V11.419h3.9l.831-2.853H7.085V4.819s-.038-1.39 1.645-1.39h2.472z"}));
}

IconFacebook.defaultProps = {"viewBox":"0 0 11.794 23.95"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
